type IClipStatus = 'muted' | 'play' | 'pause';

interface IClipStatusIconProps {
  status: IClipStatus;
}

const TITLES: Record<IClipStatus, string> = {
  muted: 'Muted',
  play: 'Paused',
  pause: 'Playing',
};

export function ClipStatusIcon({ status }: IClipStatusIconProps): React.JSX.Element {
  return (
    <div className="rounded-full bg-white/15 p-4 text-white shadow-xl ring-1 ring-white/25 backdrop-blur-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <title>{TITLES[status]}</title>
        {status === 'muted' && (
          <>
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
            <line x1="22" y1="9" x2="16" y2="15" />
            <line x1="16" y1="9" x2="22" y2="15" />
          </>
        )}
        {status === 'play' && <polygon points="6 4 20 12 6 20 6 4" fill="currentColor" />}
        {status === 'pause' && (
          <>
            <line x1="9" y1="5" x2="9" y2="19" />
            <line x1="15" y1="5" x2="15" y2="19" />
          </>
        )}
      </svg>
    </div>
  );
}
